export default "/_next/static/images/product--at-sign-legacy-e1ca881c020993313c5f10a1fcbb081c.svg";